export default {
	name: "DataTableEntriesInfo",

	props: {
		entriesInfoText: {
			type: String,
			required: true
		}
	}
};
